
export interface IErrorInfo {
    readonly errorName: string; // 产生的错误名称
    readonly errorMessage: string; // 产生的具体错误
}
class ErrorHandleConfig {
    public uploadPageError(error: Error): void {
        //
    }
}

export const errorHandleConfig = new ErrorHandleConfig();
